export default function NotFound() {
  return (
    <div className="not-found">
      <h1>Page not found</h1>
      <div>The requested page does not exist.</div>
    </div>
  );
}
